export enum AnnouncementStatus {
  ROBOCZY = 'ROBOCZY',
  OPUBLIKOWANY = 'OPUBLIKOWANY',
  BLAD = 'BLAD',
  ARCHIWALNY = 'ARCHIWALNY',
}

export const ANNOUNCEMENT_STATUS_LABELS: Record<AnnouncementStatus, string> = {
  [AnnouncementStatus.ROBOCZY]: 'Roboczy',
  [AnnouncementStatus.OPUBLIKOWANY]: 'Opublikowany',
  [AnnouncementStatus.BLAD]: 'Błąd',
  [AnnouncementStatus.ARCHIWALNY]: 'Archiwalny',
};
